export const API_KEY = 'FVugRsIjPK1or_uf5LEu3y_L3Na46UdezmKN71KS4s4'